// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"26":"2df911c1","428":"a42592a7","604":"aacd0c58","647":"5f527027","723":"b1861432","926":"b1861432"}[chunkId] + ".chunk.css";
};